function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#0A49B2",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M19.754 12.025c.11 4.135-3.496 8.024-8.185 7.852C7.41 19.717 4 16.197 4 12c0-4.148 3.397-7.95 8.025-7.877 4.443.074 7.827 3.79 7.729 7.902zm-1.243-.505c-.013-.972-.357-2.35-1.145-3.606-1.268-1.994-3.052-3.15-5.428-3.212-1.76-.05-3.273.664-4.504 1.907-2.51 2.548-2.88 6.708-.899 9.674 1.76 2.622 4.788 3.668 7.557 2.585 2.622-1.01 4.406-3.791 4.419-7.348z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11.668 14.622c.406.43.763.812 1.194 1.255-.567.554-1.157 1.132-1.773 1.698-.061.062-.246.087-.283.037-.258-.27-.566-.541-.69-.874-.073-.196.075-.566.235-.763.381-.455.849-.873 1.317-1.353zm.627-2.277c.751.701 1.403 1.317 2.031 1.895-.394.43-.75.812-1.17 1.268-.491-.517-.984-1.022-1.451-1.526-.456-.493-.443-.493.037-.973.221-.221.406-.48.553-.664zm-2.904.049c.332.357.701.763 1.12 1.194-.616.59-1.243 1.194-1.92 1.834-.185-.173-.431-.37-.628-.604-.308-.369-.295-.763.05-1.107.442-.443.91-.874 1.378-1.317zm6.129-1.576c.27.296.603.554.788.887.147.283.074.64-.197.898-.443.43-.874.874-1.33 1.33-.381-.42-.75-.838-1.107-1.231.566-.579 1.181-1.207 1.846-1.884zm-3.865-.775c.394.419.763.812 1.194 1.268-.627.615-1.255 1.243-1.834 1.821a87.846 87.846 0 0 1-1.304-1.083c.689-.714 1.304-1.341 1.944-2.006zm1.551-1.625c.652.677 1.23 1.268 1.797 1.871.062.062.062.271 0 .345-.308.381-.615.714-1.021 1.181-.69-.726-1.256-1.317-1.797-1.932-.062-.061-.074-.27-.013-.332.308-.37.64-.702 1.034-1.133zm-4.628.037c.714.714 1.33 1.33 1.97 1.982-.406.394-.8.763-1.157 1.108-.48-.456-1.022-.911-1.502-1.428-.246-.259-.197-.615.025-.91.21-.235.418-.469.664-.752zm2.327-2.203l1.932 1.933c-.394.369-.788.738-1.23 1.144-.407-.406-.85-.837-1.28-1.28-.382-.406-.382-.849 0-1.243.184-.184.368-.357.578-.554z",
  opacity: 0.7
}));

var SvgIcTcd = function SvgIcTcd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTcd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_tcd.9a6a140f.svg";
export { ForwardRef as ReactComponent };